import React, { useState } from "react";
import "../assets/css/faq.css";
import Circle from "../assets/images/circle.svg";
import Circle2 from "../assets/images/circle2.svg";
import RightArrow from "../assets/images/right_arrow.svg";
import RightArrow2 from "../assets/images/right_arrow2.svg";

function Collapsible({ questions, answers }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleCollapsible = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="collapsible-list ">
      {questions.map((question, index) => (
        <div key={index} className="collapsible-item px-2 ">
          <div className="question" onClick={() => toggleCollapsible(index)}>
            <div className="circle">
              <img alt="icon" src={openIndex === index ? Circle : Circle2} />
            </div>
            <p className="card-question">{question}</p>
            <div className="right-arrow">
              <img
                alt="icon"
                src={openIndex === index ? RightArrow : RightArrow2}
              />
            </div>
          </div>
          {openIndex === index && (
            <div className="answer px-5">
              <p>{answers[index]}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

function QuestionCard({ questions, selectedQuestion, onQuestionClick }) {
  return (
    <div className="question-card">
      <div className="overlay"></div>
      <div className="card-content">
        {questions.map((question, index) => (
          <div
            key={index}
            className={`question ${
              index === selectedQuestion ? "selected" : ""
            }`}
            onClick={() => onQuestionClick(index)}
          >
            <div className="circle">
              <img
                alt="icon"
                src={index === selectedQuestion ? Circle : Circle2}
              />
            </div>
            <p className="card-question">{question}</p>
            <div className="right-arrow">
              <img
                alt="icon"
                src={index === selectedQuestion ? RightArrow : RightArrow2}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// function AnswerCard({ answers, selectedQuestion, answerTitle }) {
//   return (
//     <div className="card answer-card">
//       <div className="answer-title">{answerTitle[selectedQuestion] || " "}</div>
//       <div className="card-content">
//         {answers[selectedQuestion] &&
//           answers[selectedQuestion]
//             .split("\n")
//             .map((line, index) => <p key={index}>{line}</p>)}
//         {!answers[selectedQuestion] && "Select a question to see the answer."}
//       </div>
//     </div>
//   );
// }

function AnswerCard({ answers, selectedQuestion, answerTitle }) {
  const answer = answers[selectedQuestion];

  const renderAnswerContent = () => {
    if (!answer) {
      return "Select a question to see the answer.";
    }

    const answerLines = answer.split("\n");

    // Check if the answer contains the KPMG International hotline and make it a hyperlink
    const answerContent = answerLines.map((line, index) => {
      if (line.includes("KPMG International hotline")) {
        const hotlineIndex = line.indexOf("KPMG International hotline");
        const beforeText = line.substring(0, hotlineIndex);
        const hotlineText = "KPMG International hotline";
        const afterText = line.substring(hotlineIndex + hotlineText.length);

        return (
          <p key={index}>
            {beforeText}{" "}
            <a
              href="https://kpmg.com/xx/en/home/campaigns/2018/01/kpmg-international-hotline.html"
              className="hotline-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {hotlineText}
            </a>
            {afterText}
          </p>
        );
      }

      return (
        <p key={index} className="answer-line">
          {line}
        </p>
      );
    });

    return answerContent;
  };

  return (
    <div className="card answer-card">
      <div className="answer-title">{answerTitle[selectedQuestion] || " "}</div>
      <div className="card-content">{renderAnswerContent()}</div>
    </div>
  );
}

function FaqSection() {
  const questions = [
    "Reporting Anonymously – Is it safe to report and how am I protected?",
    "What happens after I report",
    "What falls under being dishonest or unethical",
    "What is the role of Local Quality and Risk Management?",
    "What happens if my report is not treated satisfactorily?",
  ];

  const answers = [
    "Reporting anonymously is an option that you have for those instances where you are not comfortable reporting in another way. The Whistle blowing channels offer you the opportunity to report without disclosing your identity. The Whistle blowing process will be managed by the Ombudsman who oversees the investigation of any matter that is reported. This helps to protect the anonymity of those who choose to remain anonymous. If you choose to report anonymously, KPMG will not seek to identify you and consequently, your identity will not be divulged to the individual(s) against whom a report has been made. While conducting investigations, it may be necessary to advise others of the substance of your report or even to contact you for further information. This should be taken into account when submitting the report. It is advised that when submitting a report, adequate and complete information is provided, when reporting anonymously. In the event that a whistleblower believes that they are being victimized or subjected to a detriment by any person within the firm as a result of reporting a concern or assisting the firm in any investigation under this policy, they must inform the Ombudsman immediately and appropriate action will be taken to protect them from reprisals.",
    "All reports are investigated by Ombudsman. In instances where the Whistleblower has identified themselves, communication between the Ombudsman and the whistleblower during the investigation and conclusion is direct. (e.g. via email)",
    "It can sometimes be hard to know whether a situation should be raised as a concern.\n You should be guided by the question: If I let a situation carry on, is it likely to result in harm to our people, our firm, our client and our communities?",
    "Once a report is made, Quality and Risk Management acts as the Ombudsman and will normally discuss the report with the Risk Management Partner (provided the report does not concern him or any Quality and Risk Management team members). The Risk Management Partner provides oversight to the investigation, with an independent team, or conducts the investigation with an independent team constituted for the purpose of the report. The independent team recommends actions which are considered by the Risk management Partner. The report is forwarded to the Ombdsman to be communicated to the whistleblower.",
    "If you believe that a report has not been treated satisfactorily, you have the option of making such reports via the KPMG International hotline. The KPMG International hotline allows KPMG stakeholders to confidently report concerns. Upon receipt of your report, appropriate action(s) will be determined",
  ];

  const [selectedQuestion, setSelectedQuestion] = useState(0);

  const handleQuestionClick = (index) => {
    setSelectedQuestion(index);
  };

  return (
    <div className="App">
      <h1 className="section-title">Frequently Asked Questions</h1>
      <div className="container">
        <QuestionCard
          questions={questions}
          selectedQuestion={selectedQuestion}
          onQuestionClick={handleQuestionClick}
        />
        <AnswerCard
          answers={answers}
          selectedQuestion={selectedQuestion}
          answerTitle={questions}
        />
      </div>
      <Collapsible
        questions={questions}
        answers={answers}
        className="collapsible"
      />
    </div>
  );
}

export default FaqSection;
